export default function AboutSection() {
  return (
    <section id="about" className="bg-[#003c81] text-white py-10 md:py-16 lg:py-[100px]">
      <div className="max-w-[1200px] mx-auto px-4 md:px-8 lg:px-0">
        <div className="flex flex-col lg:flex-row gap-6 md:gap-10 lg:gap-24">
          <div className="text-[36px] md:text-[80px] lg:text-[100px] font-medium leading-[1.05]">
            <div>About</div>
            <div>Project</div>
            <div>Ontario</div>
          </div>
          <div className="flex-1 text-sm md:text-lg lg:text-xl leading-relaxed">
            <p>
              Project Ontario is a non-profit organization dedicated to rebuilding the foundations of conservative governance in our province. We believe Ontario can once again be a place of prosperity, opportunity, and good government, but only if conservatives recover the principles that made it strong.
            </p>
            <p className="mt-3 md:mt-4">
              Through public policy research, opinion writing, and civic engagement, we advance ideas that promote economic growth, personal responsibility, and institutional integrity. We host events that bring together business & civic leaders, policy thinkers, and citizens who share a desire for reform. And we work to create an appetite for serious, principled leadership within Ontario's conservative movement.
            </p>
            <p className="mt-3 md:mt-4">Project Ontario is not here to defend the status quo. We are here to shape the next generation of conservative ideas and to build the public pressure and political courage needed to put Ontario back on track.</p>
          </div>
        </div>
      </div>
    </section>
  );
}



